import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, CircularProgress,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { tr } from 'date-fns/locale';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';
import { formatDateForHasura } from '../../../utils/dateUtils';

const CompleteItemDialog = ({ open, item, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [completionDate, setCompletionDate] = useState(new Date());
  const [submissionDate, setSubmissionDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const P = 'reportManagement.complete';

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const cd = formatDateForHasura(completionDate);
      const sd = formatDateForHasura(submissionDate);
      await onConfirm(item.id, cd, sd);
    } finally {
      setLoading(false);
    }
  };

  const firmName = item?.job?.contract?.firm?.firm_name || item?.job?.firm_short_name || '';

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CheckCircleIcon color="success" />
          {t(`${P}.title`)}
        </DialogTitle>
        <DialogContent>
          {firmName && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {t(`${P}.description`, { firmName })}
            </Typography>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <DatePicker
              label={`${t(`${P}.completionDate`)} *`}
              value={completionDate}
              onChange={setCompletionDate}
              format="dd.MM.yyyy"
              views={['year', 'month', 'day']}
              slotProps={{ textField: { size: 'small', fullWidth: true } }}
            />
            <DatePicker
              label={t(`${P}.submissionDate`)}
              value={submissionDate}
              onChange={setSubmissionDate}
              format="dd.MM.yyyy"
              views={['year', 'month', 'day']}
              slotProps={{ textField: { size: 'small', fullWidth: true } }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={onClose} disabled={loading}>
            {t(`${P}.cancel`)}
          </Button>
          <Button
            variant="contained" color="success" onClick={handleConfirm}
            disabled={loading || !completionDate}
            startIcon={loading ? <CircularProgress size={16} /> : <CheckCircleIcon />}
          >
            {t(`${P}.confirm`)}
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default CompleteItemDialog;
